import * as React from "react";
import { Session } from "../types";
import { format, formatDate } from "../utils";
import { SkuCategory } from "../types-enums";
import t from "../i18n";
import Img from "../Controls/Img";
import { CatalogService } from "../services/catalog-service";

declare type SummaryReceiptProps = {
    session: Session,
    slot1?: JSX.Element,
    slot2?: JSX.Element
}
export default class SummaryReceipt extends React.Component<SummaryReceiptProps> {
    renderLocalSalesTax(localCurrencySalestax: number) {
        const session = this.props.session;
        if (session.coverSalesTax || !session.salesTax) return null;
        return (
            <div className="row summary-row">
                <div className="col-sm-6 col-7">
                    <div>{t.receipt("less_tax")} ({(session.salesTax || 0) * 100}%)</div>
                </div>
                <div className="col-sm-4 d-none d-sm-block">{format(localCurrencySalestax)} {session.currencyCode}</div>
                <div className="col-sm-2 col-5 text-right d-block d-sm-none">
                    {format(localCurrencySalestax)} {session.currencyCode}
                </div>
            </div>
        );
    }
    renderExchangeRate() {
        if (CatalogService.isSiteMovistarMX() === false) return null;
        const session = this.props.session;
        if (session.currencyCode == session.sourceCurrencyCode) return null;
        return (
            <div className="row summary-row">
                <div className="col-sm-6 col-6">
                    <div>{t.topup("exchange_rate_label")}</div>
                </div>
                <div className="col-sm-4 d-none d-sm-block">1 {session.sourceCurrencyCode} = {format(((session.localCurrencyAmount || 1) / session.faceValue))} {session.currencyCode}</div>
                <div className="col-sm-2 col-6 text-right d-block d-sm-none">
                    1 {session.sourceCurrencyCode} = {format(((session.localCurrencyAmount || 1) / session.faceValue))} {session.currencyCode}
                </div>
            </div>
        );
    }
    renderBonusAmount() {
        const coverSalesTax = this.props.session.coverSalesTax;
        const promo = this.props.session.carrierPromotion!;
        const bonusLineIncludingSalesTax = promo.bonusLineIncludingSalesTax;
        const bonusLineExcludingSalesTax = promo.bonusLineExcludingSalesTax;
        if (coverSalesTax && !bonusLineIncludingSalesTax) return null;
        if (!coverSalesTax && !bonusLineExcludingSalesTax) return null;
        return <div className="row summary-row yellow-text" style={{ paddingBottom: 0 }}>
            <div className="col-sm-6 col-7">
                <Img className="icon" src="/images/veon/Present Box.png" style={{ width: 14 }} />
                <div>{t.receipt("bonus_balance")}</div>
            </div>
            <div className="col-sm-4 d-none d-sm-block">
                {format(coverSalesTax ? bonusLineIncludingSalesTax : bonusLineExcludingSalesTax)}
            </div>
            <div className="col-sm-2 col-5 text-right d-block d-sm-none">
                {format(coverSalesTax ? bonusLineIncludingSalesTax : bonusLineExcludingSalesTax)}
            </div>
        </div>;
    }
    renderBonusData() {
        const dataLine = this.props.session.carrierPromotion!.dataLine;
        const validityLine = this.props.session.carrierPromotion!.validityLine;
        if (!dataLine) return null;
        return <div className="row summary-row yellow-text" style={{ paddingTop: 0 }}>
            <div className="col-sm-6 col-7">
                <Img className="icon" src="/images/veon/Present Box.png" style={{ width: 14 }} />
                <div>
                    {t.receipt("bonus_data")}
                    {validityLine && <React.Fragment>
                        <br /><span className="font-italic" style={{ textTransform: 'none' }}>{validityLine}</span>
                    </React.Fragment>}
                </div>
            </div>
            <div className="col-sm-4 d-none d-sm-block">{dataLine}</div>
            <div className="col-sm-2 col-5 text-right d-block d-sm-none">
                {dataLine}
            </div>
        </div>;
    }
    renderTotalAmount() {
        const coverSalesTax = this.props.session.coverSalesTax;
        const totalLineIncludingSalesTax = this.props.session.carrierPromotion!.totalLineIncludingSalesTax;
        const totalLineExcludingSalesTax = this.props.session.carrierPromotion!.totalLineExcludingSalesTax;
        if (coverSalesTax && !totalLineIncludingSalesTax) return null;
        if (!coverSalesTax && !totalLineExcludingSalesTax) return null;
        return <div className="row summary-row">
            <div className="col-sm-6 col-7">
                <div>{t.receipt("total_balance")} ({this.props.session.skuCategory==1?"RTR":this.props.session.skuCategory==2?"Data Plan":this.props.session.skuCategory==11?"Gift Card":""})</div>
                <h6><small color="#1c619a">Top-up amount may vary based on current FX rates</small></h6>
            </div>
            <div className="col-sm-4 d-none d-sm-block">
                {format(coverSalesTax ? totalLineIncludingSalesTax : totalLineExcludingSalesTax)}
            </div>
            <div className="col-sm-2 col-5 text-right d-block d-sm-none">
                {format(coverSalesTax ? totalLineIncludingSalesTax : totalLineExcludingSalesTax)}
            </div>
        </div>;
    }
    renderTotalData() {
        const totalDataLine = this.props.session.carrierPromotion!.totalDataLine;
        if (!totalDataLine) return null;
        return <div className="row summary-row">
            <div className="col-sm-6 col-7">
                <div>{t.receipt("total_data")}</div>
            </div>
            <div className="col-sm-4 d-none d-sm-block">
                {totalDataLine}
            </div>
            <div className="col-sm-2 col-5 text-right d-block d-sm-none">
                {totalDataLine}
            </div>
        </div>;
    }
    renderCoveredSalesTax(sourceCurrencySalesTax: number) {
        const session = this.props.session;
        if (session.coverSalesTax) {
            return <div className="row summary-row">
                <div className="col-sm-6 col-7">
                    <div>{t.common("sales_tax")} ({(session.salesTax || 0) * 100}%)</div>
                </div>
                <div className="col-sm-4 d-none d-sm-block" />
                <div className="col-sm-2 col-5 text-right">
                    {format(sourceCurrencySalesTax)} {session.sourceCurrencyCode}
                </div>
            </div>;
        }
        return null;
    }    
    renderGiftCardSummary() {
        if (this.props.session.skuCategory != SkuCategory.GiftCard) return null;
        const session = this.props.session;
        if (!session) return null;
        return (<React.Fragment>
            {/* <div className="summary-box font-weight-500 receipt-header-row" style={{ border: 'none' }}>
                <div className="row summary-row">
                    <div className="col-6">{t.receipt("recipient")}</div>
                    <div className="col-6 text-right">{t.receipt("amount")}</div>
                </div>
            </div> */}
            <div className="summary-box">
                <div className="row summary-row font-weight-600" style={{ fontSize: 16 }}>
                    <div className="col-6" style={{ position: 'relative' }}>
                        <i className="fa fa-gift fa-lg icon" />
                        <div className="operator-name" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{session.productName}</div>
                    </div>
                    <div className="col-6 text-right">
                        {format(session.faceValue)} {session.sourceCurrencyCode}
                    </div>
                </div>
                <div className="row summary-row">
                    <div className="col-4">{t.receipt("deliver_to")}</div>
                    <div className="col-8 text-right">{session.recipientFullName}</div>
                </div>
                <div className="row summary-row">
                    <div className="col-3">{t.receipt("delivery_email")}</div>
                    <div className="col-9 text-right">{session.recipientEmail}</div>
                </div>
                <div className="row summary-row">
                    <div className="col-4">{t.receipt("delivery_mobile")}</div>
                    <div className="col-8 text-right">+{session.internationalCode} {session.mobileNumber}</div>
                </div>
                <div className="row summary-row">
                    <div className="col-3">{t.receipt("delivery_message")}</div>
                    <div className="col-9 text-right">{session.recipientMessage}</div>
                </div>
            </div>
        </React.Fragment>);
    }
    renderTopupSummary() {
        if (this.props.session.skuCategory != SkuCategory.Topup && this.props.session.skuCategory != SkuCategory.Data) return null;
        const session = this.props.session;
        if (!session) return null;
        if (!session.carrierPromotion) return null;
        const promo = session.carrierPromotion;
        const localCurrencySalestax = promo.salesTaxInLocalCurrency;
        const planJsx = this.props.session.skuCategory === SkuCategory.Data ?
            <div className="w-100 font-weight-bold font-italic" style={{ fontSize: 12 }}>
                ({this.props.session.skuShortDescription})
            </div> : null;
        return (<React.Fragment>
            <div className="summary-box font-weight-500 receipt-header-row" style={{ border: 'none' }}>
                <div className="row summary-row">
                    <div className="col-sm-6 col-8">{t.receipt("recipient")}</div>
                    <div className="col-sm-4 d-none d-sm-block">{t.receipt("balance")}</div>
                    <div className="col-sm-2 col-4 text-right">{t.receipt("price")}</div>
                </div>
            </div>
            <div className="summary-box">
                <div className="row summary-row font-weight-600" style={{ fontSize: 16 }}>
                    <div className="col-sm-6 col-7" style={{ position: 'relative' }}>
                        <i className="fa fa-phone icon" style={{ top: 4 }} />
                        <div>+{session.internationalCode} {session.mobileNumber}</div>
                        <div className="operator-name" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{session.productName}</div>
                    </div>
                    <div className="col-sm-4 d-none d-sm-block">
                        <div>{format(session.localCurrencyAmount)} {session.currencyCode}</div>
                        {planJsx}
                    </div>
                    <div className="col-sm-2 col-5 text-right">
                        {format(session.faceValue)} {session.sourceCurrencyCode}
                    </div>
                </div>
                <div className="row summary-row d-flex d-sm-none">
                    <div className="col-7">
                        <div>{t.receipt("balance")}</div>
                    </div>
                    <div className="col-5 text-right">
                        <div>{format(session.localCurrencyAmount)} {session.currencyCode}</div>
                        {planJsx}
                    </div>
                </div>
                {this.renderExchangeRate()}
                {this.renderLocalSalesTax(localCurrencySalestax)}
                {this.renderBonusAmount()}
                {this.renderBonusData()}
            </div>
            <div className="summary-box font-weight-600">
                {this.renderTotalAmount()}
                {this.renderTotalData()}
            </div>
        </React.Fragment>);
    }
    render() {
        const session = this.props.session;
        if (!session) return null;
        if (!session.carrierPromotion) return null;
        const promo = session.carrierPromotion;
        const sourceCurrencySalesTax = session.coverSalesTax ? promo.salesTaxInSourceCurrency || 0 : 0;
        const totalAmount = session.netCharge;
        return <div>
            <div className="d-flex justify-content-between">
                <h5>{t.menu("order_summary")}</h5>
                <h5>{formatDate(session.timeCreated)}</h5>
            </div>
            <div className="summary">
                {this.renderTopupSummary()}
                {this.renderGiftCardSummary()}
                <div className="summary-box">
                    {/* {this.props.slot1} */}
                    {this.renderCoveredSalesTax(sourceCurrencySalesTax)}
                    <div className="row summary-row font-weight-600">
                        <div className="col-sm-6 col-7">
                            <div>{t.receipt("processing_fee")}</div>
                        </div>
                        <div className="col-sm-4 d-none d-sm-block" />
                        <div className="col-sm-2 col-5 text-right">
                            {format(session.processingFee)} {session.sourceCurrencyCode}
                        </div>
                    </div>
                    {!!session.smsCharge && <div className="row summary-row font-weight-600">
                        <div className="col-sm-6 col-7">
                            <div>{t.receipt("sms_charge")}</div>
                        </div>
                        <div className="col-sm-4 d-none d-sm-block" />
                        <div className="col-sm-2 col-5 text-right">
                            {format(session.smsCharge)} {session.sourceCurrencyCode}
                        </div>
                    </div>}
                    {!!session.promoCodeDiscount && <div className="row summary-row font-weight-600">
                        <div className="col-sm-6 col-7">
                            <div>{CatalogService.isSiteRedemptionPIN()?t.receipt("pin_discount_label"):t.receipt("promo_code_discount_label")}</div>
                        </div>
                        <div className="col-sm-4 d-none d-sm-block" />
                        <div className="col-sm-2 col-5 text-right">
                            {format(session.promoCodeDiscount)} {session.sourceCurrencyCode}
                        </div>
                    </div>}
                    {!!session.rewardPointDiscount && <div className="row summary-row font-weight-600">
                        <div className="col-sm-6 col-7">
                            <div>{t.receipt("reward_point_discount_label")}</div>
                        </div>
                        <div className="col-sm-4 d-none d-sm-block" />
                        <div className="col-sm-2 col-5 text-right">
                            {format(session.rewardPointDiscount)} {session.sourceCurrencyCode}
                        </div>
                    </div>}
                    <div className="row summary-row font-weight-600">
                        <div className="col-sm-6 col-7 total-payment-label">
                            <div>{t.receipt("total_payment")}</div>
                        </div>
                        <div className="col-sm-4 d-none d-sm-block" />
                        <div className="col-sm-2 col-5 text-right">
                            {format(totalAmount) ? format(totalAmount) : '0'} {session.sourceCurrencyCode}
                        </div>
                    </div>
                    {this.props.slot1}
                    {this.props.slot2}
                </div>
                {session.guestEmail && <div className="summary-box">
                    <div className="row summary-row font-weight-600">
                        <div className="col-sm-6 col-6">
                            <div>{t.receipt("guest_email_address")}</div>
                        </div>
                        <div className="col-sm-2 d-none d-sm-block" />
                        <div className="col-sm-4 col-6 text-right">
                            {session.guestEmail}
                        </div>
                    </div>
                </div>}
                {!!session.productDisclaimer && <div className="summary-box">
                    <div className="row summary-row blue-text" style={{ textTransform: "none", display: "block" }} >
                        <i className="fa fa-bell" aria-hidden="true"></i> <span>{session.productDisclaimer}</span>
                    </div>
                </div>}
            </div>
        </div>
    }
}
